import { IApiFile, IFile, IRawContractorGroupFile, IRawFile } from "@propely/propely-typings";
import DisplayedFileData from "@src/components/deprecated/FilePopup/DisplayedFileData";
import { ToastUtilities } from "@src/libs/react-toastify/ToastUtilities";
import { GlobalFileData } from "@src/to-be-removed/LocalData/Files/GlobalFileData";
import { FileDocumentData } from "@src/to-be-removed/LocalData/General/FileDocumentData";
import { FirebaseFile } from "@src/to-be-removed/LocalData/General/FirebaseFile";
import { PropertyFileData } from "@src/to-be-removed/LocalData/General/PropertyFileData";
import { downloadExternalFileURL, downloadFirebaseFile, downloadFunctionsFileURL } from "@src/to-be-removed/LocalData/General/file.utils";
import { FirebaseEvents } from "@utils/firebaseEvents";
import { useState } from "react";

const logFileDownload = (file_type: string | undefined | null) => FirebaseEvents.logEvent("global_file_opened", { file_type });

type AnyFile =
  | IRawFile
  | DisplayedFileData
  | IApiFile
  | FileDocumentData
  | FirebaseFile
  | PropertyFileData
  | GlobalFileData
  | IRawContractorGroupFile
  | IFile;

export function downloadFile(file: AnyFile, propertyID: string | undefined): Promise<any> {
  const fileName = "name" in file ? file.name : "title" in file ? file.title : undefined;
  const fileType = "type" in file ? file.type : "fileType" in file ? file.fileType : undefined;

  // 1 - If the file is a signed URL, download it directly
  if ("externalURL" in file && file.externalURL) {
    logFileDownload(fileType);
    return downloadExternalFileURL(file.externalURL, fileName);
  }

  // 4 - If the file is a Firebase file, download it
  let firebaseURL: string | undefined;

  if ("path" in file && file.path) {
    firebaseURL = file.path;
  } else if ("storagePath" in file && file.storagePath) {
    firebaseURL = file.storagePath;
  }

  if (firebaseURL) {
    logFileDownload(fileType);
    return downloadFirebaseFile(firebaseURL, fileName);
  }

  // 2 - If fileURL is available, download it directly
  /*if ("fileURL" in file && file.fileURL) {
    logFileDownload(fileType);
    return downloadExternalFileURL(file.fileURL, fileName);
  }*/

  // 3 - If the file is an external file, download it
  if ("externalFileClientID" in file && file.externalFileClientID && file instanceof PropertyFileData) {
    logFileDownload(fileType);
    return downloadFunctionsFileURL(file.parent?.id ?? propertyID ?? "", file.id, fileName ?? "");
  }
  if ("externalFileClientID" in file && file.externalFileClientID && propertyID) {
    logFileDownload(fileType);
    return downloadFunctionsFileURL(propertyID, file.id, fileName ?? "");
  }

  console.error("Error downloading file: fileURL is not available");
  ToastUtilities.presentError("Error downloading file: No file URL available.");

  return Promise.resolve();
}

export const useDownloadFile = (file: AnyFile, propertyID: string | undefined) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = () => {
    setIsDownloading(true);
    if (!isDownloading) {
      downloadFile(file, propertyID).finally(() => setIsDownloading(false));
    }
  };

  return {
    isDownloading,
    download,
  };
};
